module.exports = __webpack_public_path__ + "img/menuIcon5.f2ce77cc.png";